"use client";

import { useProductLinkProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/useProductLinkProps";
import { ProductTileClickContext } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/ProductTileClickContext";
import { SearchProductTileClickProviderProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProviderProps";
import { useOnProductClickForSearchPage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";
import React, { ReactNode } from "react";

export const SearchProductTileClickProvider = ({
  data: {
    productToken,
    impressionId,
    images,
    isPromoted,
    promotedBy,
    badgeList,
    brandToken,
    selectedProductOptionToken,
    bestImage,
  },
  children,
}: {
  data: SearchProductTileClickProviderProps;
  children: ReactNode;
}) => {
  const { onProductClick } = useOnProductClickForSearchPage({
    token: productToken,
    isPromoted,
    impressionId,
    promotedBy,
    badgeList,
    bestImage,
    images,
  });

  const productLinkProps = useProductLinkProps({
    token: productToken,
    brandToken,
    impressionId,
    selectedProductOptionToken,
  });

  return (
    <ProductTileClickContext.Provider
      value={{ productLinkProps, onProductClick }}
    >
      {children}
    </ProductTileClickContext.Provider>
  );
};
